export default __webpack_public_path__ + "static/media/messenger.38058891.svg";